import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/partnersPage/PartnersComponents.tsx");
